import React from 'react';
import {
    StyledContent, StyledExploreContent, StyledSideBar, StyledTopPanel, StyledWrapper
} from './styles';

type IExploreContentLayout = React.FC & {
    TopPanel: typeof TopPanel;
    Content: typeof Content;
    SideBar: typeof SideBar;
    ExploreContent: typeof ExploreContent;
}

export const ExploreContentLayout: IExploreContentLayout = ({ children }) => (
    <StyledWrapper>
        {children}
    </StyledWrapper>
);

const TopPanel: React.FC = ({ children }) => (
    <StyledTopPanel alignItems='center'>
        {children}
    </StyledTopPanel>
);

const Content: React.FC = ({ children }) => (
    <StyledContent>
        {children}
    </StyledContent>
);

const SideBar: React.FC<{ opened: boolean }> = ({ opened, children }) => (
    <StyledSideBar visible={opened}>
        {children}
    </StyledSideBar>
);

const ExploreContent: React.FC = ({ children }) => (
    <StyledExploreContent>
        {children}
    </StyledExploreContent>
);

ExploreContentLayout.TopPanel = TopPanel;
ExploreContentLayout.Content = Content;
ExploreContentLayout.SideBar = SideBar;
ExploreContentLayout.ExploreContent = ExploreContent;
